/* eslint-disable react/prop-types */
import React from 'react';

export function Background({ active, className = '', src, opacity = 1 }) {
  if (!active) {
    return null;
  }
  return <div className={`background ${className}`} style={{ backgroundImage: `url(${src})`, opacity }} />;
}
